import React, { useEffect } from 'react';
import { useDiagnostic } from './hooks/useDiagnostic';
import { HookSection } from './components/HookSection';
import { Diagnostic } from './components/Diagnostic';
import { EmailGate } from './components/EmailGate';
import { ResultScreen } from './components/ResultScreen';
import { FaqSection } from './components/FaqSection';
const AVY_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/fCA64Eya9x3RdLdNE1sqrW/AVY_LOGO.svg';
export function App() {
  useEffect(() => {
    document.title = 'UX Guide';
  }, []);
  const {
    step,
    currentQuestion,
    questionIndex,
    totalQuestions,
    startDiagnostic,
    answerQuestion,
    submitEmail,
    resultTier
  } = useDiagnostic();
  return <div style={{
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#FAFAF8',
    display: 'flex',
    flexDirection: 'column'
  }} data-id="element-0">
      {/* Header */}
      <header style={{
      padding: '1.25rem 1.5rem'
    }} data-id="element-1">
        <div style={{
        maxWidth: '32rem',
        margin: '0 auto'
      }} data-id="element-2">
          <a href="https://avy.me" aria-label="AVY homepage" data-id="element-3">
            <img src={AVY_LOGO_URL} alt="AVY" style={{
            height: '2.5rem',
            width: '2.5rem'
          }} data-id="element-4" />
          </a>
        </div>
      </header>

      {/* Main */}
      <main style={{
      flex: 1,
      padding: '2.5rem 1.5rem'
    }} data-id="element-5">
        <div style={{
        maxWidth: '32rem',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '4rem'
      }} data-id="element-6">
          {step === 'hook' && <HookSection onStart={startDiagnostic} data-id="element-7" />}
          {step === 'diagnostic' && <Diagnostic question={currentQuestion} questionIndex={questionIndex} totalQuestions={totalQuestions} onAnswer={answerQuestion} data-id="element-8" />}
          {step === 'email' && <EmailGate onSubmit={submitEmail} data-id="element-9" />}
          {step === 'result' && <ResultScreen tier={resultTier} data-id="element-10" />}
          <FaqSection data-id="element-11" />
        </div>
      </main>

      {/* Footer */}
      <footer style={{
      padding: '2.5rem 1.5rem',
      borderTop: '1px solid #E5E5E0'
    }} data-id="element-12">
        <div style={{
        maxWidth: '32rem',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      }} data-id="element-13">
          <p style={{
          fontSize: '0.875rem',
          color: '#8A8A85',
          lineHeight: '1.6'
        }} data-id="element-14">
            AVY® Consultancy Ltd, Company number: 12143361
            <br data-id="element-15" />
            Birmingham, United Kingdom
          </p>
          <div style={{
          display: 'flex',
          gap: '1rem',
          fontSize: '0.875rem'
        }} data-id="element-16">
            <a href="https://avy.me" style={{
            color: '#8A8A85'
          }} data-id="element-17">
              Visit avy.me
            </a>
            <a href="https://avy.me/privacy-policy/" style={{
            color: '#8A8A85'
          }} data-id="element-18">
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    </div>;
}